import { createApi } from "@reduxjs/toolkit/query/react";
import { VITE_API_V2_URL } from "codes";
import { axiosBaseQuery } from "helpers/axiosbaseQuery";

export const funder = createApi({
  reducerPath: "funder",
  tagTypes: ["FUNDERS"],
  baseQuery: axiosBaseQuery({
    baseUrl: `${VITE_API_V2_URL}/funder`,
  }),
  endpoints: (builder) => ({
    //Funder
    getAllFunder: builder.query<
      { id: string; name: string; funder_type: string; is_active?: boolean }[],
      null
    >({
      query: () => ({
        url: `/list`,
        method: "get",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["FUNDERS"],
    }),
  }),
});

export const { useGetAllFunderQuery } = funder;
